import PropTypes from 'prop-types';
import React from 'react';
import Waveform from './core/Waveform';
var TrackRowWaveform = function TrackRowWaveform(_ref) {
  var track = _ref.track;
  return /*#__PURE__*/React.createElement(Waveform, {
    track: track
  });
};
TrackRowWaveform.propTypes = {
  track: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired
};
export default /*#__PURE__*/React.memo(TrackRowWaveform);